(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-videos]');
    if (!root) return;
    const dialog = root.querySelector('[data-video-dialog]');
    const closeBtn = root.querySelector('[data-video-close]');
    const park = root.querySelector('[data-video-roots]');
    if (!dialog) return;

    // Umami video tracking (mirrors frontend/lib/gallery.js). Concept-D players are
    // reused elements whose src is swapped per video, so videoId is read from
    // data-video-id at event time and milestones reset per swap.
    function attachTracking(videoEl) {
      if (!videoEl || videoEl._tracked) return;
      videoEl._tracked = true;
      videoEl._milestones = new Set();
      const meta = function () {
        return {
          videoId: videoEl.dataset.videoId || 'unknown',
          productTitle: root.dataset.productTitle || '',
          productHandle: root.dataset.productHandle || '',
        };
      };
      videoEl.addEventListener('play', function () {
        try { window.umami && window.umami.track('product_video_play', meta()); } catch (e) {}
      });
      videoEl.addEventListener('timeupdate', function () {
        const duration = videoEl.duration;
        if (!duration) return;
        const pct = (videoEl.currentTime / duration) * 100;
        [25, 50, 75, 100].forEach(function (milestone) {
          if (pct >= milestone && !videoEl._milestones.has(milestone)) {
            videoEl._milestones.add(milestone);
            try {
              window.umami && window.umami.track('product_video_progress', Object.assign(meta(), {
                milestone: milestone,
                watchedSeconds: Math.round(videoEl.currentTime),
                durationSeconds: Math.round(duration),
              }));
            } catch (e) {}
          }
        });
      });
      videoEl.addEventListener('ended', function () {
        try {
          window.umami && window.umami.track('product_video_complete', Object.assign(meta(), {
            durationSeconds: Math.round(videoEl.duration || 0),
          }));
        } catch (e) {}
      });
    }

    root.querySelectorAll('[data-d-player]').forEach(attachTracking);

    // ---- the modal: a pre-rendered player root ([data-video-roots] > [data-pv-root])
    // is moved into the dialog while it is open and parked again on close. The player
    // itself is frontend/entrypoints/video-watch.js, initialised on every root.
    let active = null;

    function open(trigger) {
      const key = trigger.dataset.videoPv || '';
      const r = key && park ? park.querySelector('[data-pv-root="' + key.replace(/"/g, '') + '"]') : null;
      if (!r) {
        // no pre-rendered player (video without a file): follow the card's link if it has one
        if (trigger.tagName === 'A' && trigger.href) location.href = trigger.href;
        return;
      }
      const video = r.querySelector('[data-vw-player]');
      if (!video) return;
      video.dataset.videoId = trigger.dataset.videoId || 'unknown';
      if (video._milestones) video._milestones.clear();
      attachTracking(video);
      active = r;
      dialog.appendChild(r);
      r.hidden = false;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    }

    function close() {
      if (active) {
        const video = active.querySelector('[data-vw-player]');
        try { if (video) video.pause(); } catch (e) {}
        active.hidden = true;
        if (park) park.appendChild(active);
        active = null;
      }
      if (dialog.open) dialog.close();
    }

    function swapDPlayer(dContainer, trigger) {
      const dPlayer = dContainer.querySelector('[data-d-player]');
      const dSource = dContainer.querySelector('[data-d-source]');
      const dTitle = dContainer.querySelector('[data-d-title]');
      if (!dPlayer || !dSource) return;
      dPlayer.dataset.videoId = trigger.dataset.videoId || 'unknown';
      if (dPlayer._milestones) dPlayer._milestones.clear();
      dSource.setAttribute('src', trigger.dataset.videoSrc);
      if (trigger.dataset.videoMime) dSource.setAttribute('type', trigger.dataset.videoMime);
      if (trigger.dataset.videoPoster) dPlayer.setAttribute('poster', trigger.dataset.videoPoster);
      try { dPlayer.load(); } catch (e) {}
      const p = dPlayer.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
      if (dTitle && trigger.dataset.videoTitle) dTitle.textContent = trigger.dataset.videoTitle;
      dContainer.querySelectorAll('[data-video-open]').forEach(function (btn) {
        btn.removeAttribute('aria-current');
      });
      trigger.setAttribute('aria-current', 'true');
    }

    root.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-video-open]');
      if (!trigger) return;
      // The card is a link to the watch page; a modifier click (new tab) follows it,
      // a plain click opens the modal instead.
      if (trigger.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) return;
      e.preventDefault();
      const dContainer = trigger.closest('.product-videos--D');
      if (dContainer) {
        swapDPlayer(dContainer, trigger);
        return;
      }
      open(trigger);
    });

    // chapter clicks inside the modal (handled by the player island) are worth an event
    dialog.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-vw-seek]');
      if (!btn || !active) return;
      const video = active.querySelector('[data-vw-player]');
      try {
        window.umami && window.umami.track('product_video_chapter', {
          videoId: (video && video.dataset.videoId) || 'unknown',
          productHandle: root.dataset.productHandle || '',
          chapter: btn.textContent.trim().replace(/\s+/g, ' '),
          seconds: Number(btn.getAttribute('data-vw-seek')) || 0,
        });
      } catch (err) {}
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    dialog.addEventListener('close', close);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
